export default "__VITE_ASSET__S1hDr7HI__"